export class ApplicantsConstants {
  static STATUS_ON = 1;
  static STATUS_OFF = 2;
}
